<template>
  <div>
    <div>
      <system-bar></system-bar>
      <admin-menu></admin-menu>
    </div>
    <div>
      <v-card>
        <v-card-title>
          <v-btn @click="redirectTo('/admin/users/create-admin')">Create Admin</v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headers" :items="admin">
            <template v-slot:item.actions="{ item }">
              <v-btn @click="redirectTo('/admin/users/edit-admin/' + item._id)"
                >Edit</v-btn
              >
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import SystemBar from "../../../library/system-bar/system-bar";
import AdminMenu from "../../menubar/menubar";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "AdminList",
  components: {
    "admin-menu": AdminMenu,
    "system-bar": SystemBar,
  },
  data() {
    return {
      headers: [
        {
          value: "email",
          text: "Email",
        },
        {
          value: "fullname",
          text: "Name/Surname",
        },

        {
          value: "actions",
          text: "Actions",
        },
      ],
      admin: [],
      url: process.env.VUE_APP_LOYALTY_API_URI,
      custId: process.env.VUE_APP_OGF_CUST_ID,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters({
      listAdmin: "BFC/getAdminList",
    }),
  },
  methods: {
    ...mapActions({
      setAdminList: "BFC/setListAdmin",
    }),
    redirectTo(path) {
      this.$router.push(path);
    },
    async init() {
      let payload = {
        custId: this.custId,
      };

      try {
        await axios
          .post(
            this.url + "/api/bfc/v1/admin/listAdminUser",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
              },
            }
          )
          .then(async (response) => {
            // console.log(response);
            console.log(response.data);
            if (response.data.statusCode == 0) {
              console.log(response);
              this.setAdminList(response.data.data);
              this.admin = response.data.data.map((item) => {
                //
                console.log(item);
                return {
                  //no: n,
                  _id: item._id,
                  email: item.email,
                  fullname: item.firstname + " " + item.lastname,
                  //totalCases: 0,
                  //lastPayment: "-",
                };
              });
              console.log(this.admin);
              //this.admin = this.getAdminList;
            } else {
              // show error
              console.log("error response");
            }
          });
      } catch (e) {
        //
        console.log(e);
      }
    },
  },
};
</script>
